exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".osv-app-alert.osv-alert-fixed{position:fixed;top:10px;right:10px;z-index:100}.osv-app-alert.osv-alert-relative{position:relative;margin-bottom:10px;margin-top:10px}.osv-app-alert.message.is-danger .message-body{color:#cc0f35}", ""]);

// exports
